console.log("Planner JS loaded");
/* =========================================================
   ⚙️ OWNER CONFIG — EDIT THESE TWO LINES
========================================================= */
const OWNER_WHATSAPP = '919718076609';            // leads & quotes arrive here
const OWNER_EMAIL    = 'REPLACE-WITH-YOUR-EMAIL@gmail.com'; // leads emailed here via FormSubmit.co (free) — replace, then confirm the activation email FormSubmit sends on first lead

/* =========================================================
   CLINIC DATA
========================================================= */
const SPECIALTIES = [
 {id:'gp', ico:'🩺', nm:'General Physician', ct:'OPD / family clinic'},
 {id:'gynae', ico:'🤰', nm:'Gynaecology', ct:'Obs & gynae OPD'},
 {id:'ortho', ico:'🦴', nm:'Orthopaedics', ct:'Bone & joint clinic'},
 {id:'pedia', ico:'👶', nm:'Paediatrics', ct:'Child clinic + vaccines'},
 {id:'dental', ico:'🦷', nm:'Dental', ct:'Dental chair setup'},
 {id:'ent', ico:'👂', nm:'ENT', ct:'Ear, nose & throat'},
 {id:'derma', ico:'✨', nm:'Dermatology', ct:'Skin & aesthetics'},
 {id:'eye', ico:'👁️', nm:'Ophthalmology', ct:'Eye clinic'},
 {id:'physio', ico:'💪', nm:'Physiotherapy', ct:'Physio & rehab centre'},
 {id:'poly', ico:'🏥', nm:'Polyclinic', ct:'Multi-doctor OPD'},
];
const ADDONS = [
 {id:'daycare', tl:'Daycare beds (2–4 beds)', td:'Observation / IV / short stay — Fowler beds, lockers, IV stands'},
 {id:'minorOT', tl:'Minor OT / procedure room', td:'OT table, OT light, cautery, suction, instrument sets'},
 {id:'pharmacy', tl:'In-clinic pharmacy', td:'Adds drug licence to checklist + medicine racks'},
 {id:'lab', tl:'Sample collection corner', td:'Phlebotomy chair, sample fridge, centrifuge'},
];
const ITEMS = [ 
 {id:'exam_table', nm:'Examination table, 2-section SS', pr:7500, cat:'F', m:1, def:1, common:1},
 {id:'doc_table', nm:'Doctor consultation table', pr:9000, cat:'F', m:1, def:1, common:1},
 {id:'doc_chair', nm:'Doctor revolving chair', pr:4500, cat:'F', m:1, def:1, common:1},
 {id:'vis_chair', nm:'Patient/visitor chairs (set of 2)', pr:3200, cat:'F', m:1, def:1, common:1},
 {id:'rev_stool', nm:'Revolving stool, SS', pr:1800, cat:'F', m:1, def:1, common:1},
 {id:'footstep', nm:'Footstep double, SS', pr:1500, cat:'F', m:1, def:1, common:1},
 {id:'screen', nm:'Bedside screen, 3-panel', pr:4800, cat:'F', m:1, def:1, common:1},
 {id:'med_cab', nm:'Medicine / instrument cabinet', pr:12000, cat:'F', m:1, def:1, common:1},
 {id:'xray_view', nm:'X-ray view box, LED', pr:3500, cat:'F', m:1, def:0, common:1},
 {id:'wait_chair', nm:'Waiting chairs, 3-seater SS', pr:8500, cat:'F', m:1, def:2, common:1},
 {id:'recep_desk', nm:'Reception desk', pr:15000, cat:'F', m:1, def:1, common:1},
 {id:'wheelchair', nm:'Wheelchair, folding', pr:6500, cat:'F', m:1, def:1, common:1},
 {id:'stretcher', nm:'Patient stretcher trolley', pr:12500, cat:'F', m:1, def:0, common:1},
 {id:'inst_trolley', nm:'Instrument trolley, SS', pr:6500, cat:'S', m:1, def:1, common:1},
 {id:'dress_drum', nm:'Dressing drum set (2 pc)', pr:2200, cat:'S', m:1, def:1, common:1},
 {id:'kidney_tray', nm:'Kidney trays + SS tray set', pr:900, cat:'S', m:1, def:2, common:1},
 {id:'dressing_set', nm:'Dressing instrument set', pr:2800, cat:'S', m:1, def:1, common:1},
 {id:'autoclave', nm:'Autoclave, portable 21 L', pr:14000, cat:'S', m:1, def:1, common:1},
 {id:'uv_cab', nm:'UV sterilizer cabinet', pr:9000, cat:'S', m:1, def:0, common:1},
 {id:'waste_bins', nm:'Colour-coded BMW bins (set of 4)', pr:3200, cat:'S', m:1, def:1, common:1},
 {id:'iv_stand', nm:'IV / saline stand, SS', pr:1800, cat:'S', m:1, def:1, common:1},
 {id:'bp', nm:'BP apparatus, aneroid + stand', pr:1800, cat:'D', m:0, def:1, common:1},
 {id:'steth', nm:'Stethoscope', pr:1200, cat:'D', m:0, def:1, common:1},
 {id:'scale', nm:'Weighing scale, adult', pr:2500, cat:'D', m:0, def:1, common:1},
 {id:'oxim', nm:'Pulse oximeter', pr:1500, cat:'D', m:0, def:1, common:1},
 {id:'gluco', nm:'Glucometer + strips', pr:1500, cat:'D', m:0, def:1, common:1},
 {id:'thermo', nm:'IR thermometer', pr:1500, cat:'D', m:0, def:1, common:1},
 {id:'nebu', nm:'Nebulizer', pr:2200, cat:'D', m:0, def:1, common:1},
 {id:'o2', nm:'Oxygen cylinder B-type + flowmeter', pr:9500, cat:'D', m:0, def:1, common:1},
 {id:'ambu', nm:'Ambu bag, adult', pr:1800, cat:'D', m:0, def:1, common:1},
 {id:'crash', nm:'Emergency crash cart', pr:18000, cat:'S', m:1, def:0, common:1},
 {id:'fridge', nm:'Medicine refrigerator, 90 L', pr:16000, cat:'D', m:0, def:0, common:1},
 {id:'ecg', nm:'ECG machine, 3-channel', pr:32000, cat:'D', m:0, def:0, common:1},
 {id:'suction', nm:'Suction machine', pr:8500, cat:'D', m:1, def:0, common:1},
 {id:'gy_table', nm:'Gynae examination table with stirrups', pr:14500, cat:'X', m:1, def:1, sp:['gynae']},
 {id:'gy_doppler', nm:'Foetal doppler', pr:6500, cat:'X', m:0, def:1, sp:['gynae']},
 {id:'gy_set', nm:'Gynae instrument set (Cusco, Sims, etc.)', pr:8500, cat:'X', m:1, def:1, sp:['gynae']},
 {id:'gy_warmer', nm:'Baby warmer / resuscitaire', pr:45000, cat:'X', m:1, def:0, sp:['gynae']},
 {id:'or_table', nm:'Ortho examination table, heavy-duty', pr:12000, cat:'X', m:1, def:1, sp:['ortho']},
 {id:'or_cutter', nm:'Plaster cutter, electric', pr:9500, cat:'X', m:0, def:1, sp:['ortho']},
 {id:'or_traction', nm:'Traction kit, complete', pr:8500, cat:'X', m:1, def:1, sp:['ortho']},
 {id:'or_walk', nm:'Walkers + crutches stock', pr:4500, cat:'X', m:1, def:1, sp:['ortho']},
 {id:'or_drill', nm:'Bone drill set', pr:22000, cat:'X', m:0, def:0, sp:['ortho']},
 {id:'pd_scale', nm:'Baby weighing scale', pr:4500, cat:'X', m:0, def:1, sp:['pedia']},
 {id:'pd_infant', nm:'Infantometer + stadiometer', pr:3800, cat:'X', m:0, def:1, sp:['pedia']},
 {id:'pd_cuff', nm:'Paediatric BP cuff set', pr:1200, cat:'X', m:0, def:1, sp:['pedia']},
 {id:'pd_fridge', nm:'Vaccine refrigerator (ILR-type)', pr:28000, cat:'X', m:0, def:1, sp:['pedia']},
 {id:'dn_chair', nm:'Dental chair, electric (full unit)', pr:165000, cat:'X', m:0, def:1, sp:['dental']},
 {id:'dn_comp', nm:'Air compressor, oil-free', pr:28000, cat:'X', m:0, def:1, sp:['dental']},
 {id:'dn_scaler', nm:'Ultrasonic scaler', pr:14000, cat:'X', m:0, def:1, sp:['dental']},
 {id:'dn_cure', nm:'Light cure unit', pr:4500, cat:'X', m:0, def:1, sp:['dental']},
 {id:'dn_rvg', nm:'Dental X-ray + RVG sensor', pr:90000, cat:'X', m:0, def:0, sp:['dental']},
 {id:'dn_bclass', nm:'Autoclave, B-class 18 L', pr:55000, cat:'X', m:0, def:1, sp:['dental']},
 {id:'en_unit', nm:'ENT treatment unit', pr:95000, cat:'X', m:0, def:0, sp:['ent']},
 {id:'en_chair', nm:'ENT examination chair', pr:35000, cat:'X', m:1, def:1, sp:['ent']},
 {id:'en_oto', nm:'Otoscope + headlight LED', pr:9500, cat:'X', m:0, def:1, sp:['ent']},
 {id:'en_set', nm:'ENT instrument set', pr:7500, cat:'X', m:1, def:1, sp:['ent']},
 {id:'dr_chair', nm:'Derma procedure chair', pr:28000, cat:'X', m:1, def:1, sp:['derma']},
 {id:'dr_lamp', nm:'Magnifying examination lamp', pr:4500, cat:'X', m:0, def:1, sp:['derma']},
 {id:'dr_cautery', nm:'Electrocautery / RF unit', pr:18000, cat:'X', m:0, def:1, sp:['derma']},
 {id:'dr_cryo', nm:'Cryotherapy unit', pr:12000, cat:'X', m:0, def:0, sp:['derma']},
 {id:'ey_slit', nm:'Slit lamp', pr:120000, cat:'X', m:0, def:1, sp:['eye']},
 {id:'ey_trial', nm:'Trial lens set + frame', pr:13500, cat:'X', m:0, def:1, sp:['eye']},
 {id:'ey_chart', nm:'Vision drum / chart, LED', pr:3500, cat:'X', m:0, def:1, sp:['eye']},
 {id:'ey_ophth', nm:'Ophthalmoscope + retinoscope', pr:18000, cat:'X', m:0, def:1, sp:['eye']},
 {id:'ey_unit', nm:'Refraction chair unit', pr:85000, cat:'X', m:0, def:0, sp:['eye']},
 {id:'ph_table', nm:'Physio treatment tables', pr:9500, cat:'X', m:1, def:2, sp:['physio']},
 {id:'ph_ift', nm:'IFT machine', pr:28000, cat:'X', m:0, def:1, sp:['physio']},
 {id:'ph_us', nm:'Ultrasound therapy unit', pr:18000, cat:'X', m:0, def:1, sp:['physio']},
 {id:'ph_tens', nm:'TENS unit', pr:6500, cat:'X', m:0, def:1, sp:['physio']},
 {id:'ph_para', nm:'Parallel bars + shoulder wheel', pr:22000, cat:'X', m:1, def:1, sp:['physio']},
 {id:'ph_misc', nm:'Mats, weights, theraband kit', pr:6000, cat:'X', m:0, def:1, sp:['physio']},
 {id:'po_exam2', nm:'Extra consultation room set (table+chair+exam table)', pr:21000, cat:'X', m:1, def:1, sp:['poly']},
 {id:'po_wait2', nm:'Extra waiting chairs, 3-seater (set of 2)', pr:17000, cat:'X', m:1, def:1, sp:['poly']},
 {id:'dc_bed', nm:'Fowler bed, semi (2-function)', pr:16500, cat:'A', m:1, def:2, ad:'daycare'},
 {id:'dc_mat', nm:'Hospital mattress, 4"', pr:3200, cat:'A', m:1, def:2, ad:'daycare'},
 {id:'dc_locker', nm:'Bedside locker', pr:4500, cat:'A', m:1, def:2, ad:'daycare'},
 {id:'dc_obt', nm:'Overbed table', pr:4200, cat:'A', m:1, def:2, ad:'daycare'},
 {id:'dc_iv', nm:'IV stands (extra)', pr:1800, cat:'A', m:1, def:2, ad:'daycare'},
 {id:'ot_table', nm:'OT table, hydraulic (minor)', pr:65000, cat:'A', m:1, def:1, ad:'minorOT'},
 {id:'ot_light', nm:'OT light, mobile 4-reflector', pr:28000, cat:'A', m:1, def:1, ad:'minorOT'},
 {id:'ot_cautery', nm:'Surgical cautery unit', pr:25000, cat:'A', m:0, def:1, ad:'minorOT'},
 {id:'ot_suction', nm:'High-vacuum suction machine', pr:12500, cat:'A', m:1, def:1, ad:'minorOT'},
 {id:'ot_set', nm:'Minor OT instrument set', pr:15000, cat:'A', m:1, def:1, ad:'minorOT'},
 {id:'ot_mayo', nm:'Mayo trolley, SS', pr:5500, cat:'A', m:1, def:1, ad:'minorOT'},
 {id:'rx_rack', nm:'Medicine racks, SS (set of 3)', pr:18000, cat:'A', m:1, def:1, ad:'pharmacy'},
 {id:'rx_counter', nm:'Dispensing counter', pr:14000, cat:'A', m:1, def:1, ad:'pharmacy'},
 {id:'rx_fridge', nm:'Pharmacy refrigerator', pr:16000, cat:'A', m:0, def:1, ad:'pharmacy'},
 {id:'lb_chair', nm:'Phlebotomy / blood draw chair', pr:9500, cat:'A', m:1, def:1, ad:'lab'},
 {id:'lb_fuge', nm:'Centrifuge, 8-tube', pr:9000, cat:'A', m:0, def:1, ad:'lab'},
 {id:'lb_fridge', nm:'Sample refrigerator, small', pr:12000, cat:'A', m:0, def:1, ad:'lab'},
];
const CATS = {F:'Clinic furniture', S:'Surgical & SS items', D:'Diagnostics & emergency', X:'Specialty equipment', A:'Add-on equipment'};

/* =========================================================
   HOSPITAL DATA — 10 to 500 beds
========================================================= */
const BEDS = [10,25,50,100,200,300,500];
const otCount = b => b<=10?1 : b<=25?2 : b<=50?3 : b<=100?4 : b<=200?6 : b<=300?8 : 12;
const R = (x,min=1)=>Math.max(min, Math.round(x));
const C = (x,min=1)=>Math.max(min, Math.ceil(x));

const DEPTS = [
 {id:'ward', ico:'🛏️', nm:'General wards', minB:10, def:b=>true},
 {id:'icu',  ico:'💓', nm:'ICU / CCU', minB:10, def:b=>true},
 {id:'er',   ico:'🚑', nm:'Emergency / Casualty', minB:10, def:b=>true},
 {id:'ot',   ico:'🔪', nm:'OT complex', minB:10, def:b=>true},
 {id:'mat',  ico:'🤱', nm:'Maternity / Labour room', minB:10, def:b=>true},
 {id:'nicu', ico:'👶', nm:'NICU', minB:50, def:b=>b>=50},
 {id:'opd',  ico:'🩺', nm:'OPD block', minB:10, def:b=>true},
 {id:'rad',  ico:'☢️', nm:'Radiology / Imaging', minB:25, def:b=>b>=25},
 {id:'lab',  ico:'🧪', nm:'Laboratory', minB:10, def:b=>true},
 {id:'cssd', ico:'♨️', nm:'CSSD / Sterilization', minB:25, def:b=>b>=25},
 {id:'dia',  ico:'🩸', nm:'Dialysis unit', minB:100, def:b=>false},
 {id:'bb',   ico:'🆎', nm:'Blood bank', minB:100, def:b=>false},
 {id:'phy',  ico:'💪', nm:'Physiotherapy', minB:50, def:b=>b>=100},
 {id:'sup',  ico:'🍽️', nm:'Support (kitchen·laundry·mortuary)', minB:25, def:b=>b>=50},
];

const HITEMS = [
 {id:'h_fowler', dp:'ward', nm:'Fowler bed, 2-function ABS panels', pr:16500, m:1, qf:b=>C(b*0.55)},
 {id:'h_mat', dp:'ward', nm:'Hospital mattress, 4"', pr:3200, m:1, qf:b=>C(b*0.85)},
 {id:'h_locker', dp:'ward', nm:'Bedside locker', pr:4500, m:1, qf:b=>C(b*0.85)},
 {id:'h_obt', dp:'ward', nm:'Overbed table', pr:4200, m:1, qf:b=>C(b*0.7)},
 {id:'h_iv', dp:'ward', nm:'IV / saline stand, SS', pr:1800, m:1, qf:b=>C(b*0.9)},
 {id:'h_screen', dp:'ward', nm:'Bedside screen, 3-panel', pr:4800, m:1, qf:b=>C(b/5)},
 {id:'h_nurse', dp:'ward', nm:'Nursing station counter', pr:35000, m:1, qf:b=>C(b/25)},
 {id:'h_medtrolley', dp:'ward', nm:'Medicine trolley', pr:14000, m:1, qf:b=>C(b/20)},
 {id:'h_dresstrolley', dp:'ward', nm:'Dressing trolley, SS', pr:8500, m:1, qf:b=>C(b/20)},
 {id:'h_wheelchair', dp:'ward', nm:'Wheelchair, folding', pr:6500, m:1, qf:b=>C(b/20,2)},
 {id:'h_stretcher', dp:'ward', nm:'Patient stretcher trolley, hydraulic', pr:22000, m:1, qf:b=>C(b/30,2)},
 {id:'h_examlight', dp:'ward', nm:'Examination light, mobile', pr:6500, m:1, qf:b=>C(b/25)},
 {id:'h_crash_w', dp:'ward', nm:'Crash cart (ward)', pr:18000, m:1, qf:b=>C(b/30)},
 {id:'h_icubed', dp:'icu', nm:'ICU bed, 5-function mechanical', pr:65000, m:1, qf:b=>R(b*0.12,2)},
 {id:'h_icumat', dp:'icu', nm:'ICU mattress + air mattress', pr:8500, m:1, qf:b=>R(b*0.12,2)},
 {id:'h_monitor', dp:'icu', nm:'Multipara monitor, 5-para', pr:85000, m:0, qf:(b,ot)=>R(b*0.12,2)+ot},
 {id:'h_vent', dp:'icu', nm:'ICU ventilator', pr:650000, m:0, qf:b=>C(b*0.06,1)},
 {id:'h_syr', dp:'icu', nm:'Syringe pump', pr:28000, m:0, qf:b=>R(b*0.24,4)},
 {id:'h_inf', dp:'icu', nm:'Infusion pump', pr:32000, m:0, qf:b=>R(b*0.12,2)},
 {id:'h_defib', dp:'icu', nm:'Defibrillator, biphasic', pr:185000, m:0, qf:b=>C(b/100,1)},
 {id:'h_abg', dp:'icu', nm:'ABG analyzer', pr:550000, m:0, qf:b=>b>=100?1:0},
 {id:'h_icusuction', dp:'icu', nm:'High-vacuum suction machine', pr:12500, m:1, qf:b=>C(b*0.06,2)},
 {id:'h_erbed', dp:'er', nm:'Emergency recovery trolley, hydraulic', pr:22000, m:1, qf:b=>R(b*0.05,2)},
 {id:'h_ercrash', dp:'er', nm:'Crash cart, fully loaded', pr:18000, m:1, qf:b=>C(b/100,1)},
 {id:'h_erdefib', dp:'er', nm:'Defibrillator + AED', pr:185000, m:0, qf:b=>1},
 {id:'h_ermon', dp:'er', nm:'Patient monitor (ER)', pr:85000, m:0, qf:b=>R(b*0.025,1)},
 {id:'h_erecg', dp:'er', nm:'ECG machine, 12-channel', pr:65000, m:0, qf:b=>1},
 {id:'h_ernebu', dp:'er', nm:'Nebulizer + ambu kit', pr:4500, m:0, qf:b=>C(b/50,2)},
 {id:'h_ottable', dp:'ot', nm:'OT table, hydraulic C-arm compatible', pr:185000, m:1, qf:(b,ot)=>ot},
 {id:'h_otlight', dp:'ot', nm:'OT light, ceiling LED double-dome', pr:165000, m:1, qf:(b,ot)=>ot},
 {id:'h_anaes', dp:'ot', nm:'Anaesthesia workstation', pr:750000, m:0, qf:(b,ot)=>ot},
 {id:'h_cautery', dp:'ot', nm:'Surgical cautery, 400 W', pr:125000, m:0, qf:(b,ot)=>ot},
 {id:'h_otmon', dp:'ot', nm:'OT patient monitor', pr:85000, m:0, qf:(b,ot)=>ot},
 {id:'h_otsuction', dp:'ot', nm:'OT suction, high-vacuum trolley', pr:18500, m:1, qf:(b,ot)=>ot},
 {id:'h_otinstr', dp:'ot', nm:'Major instrument sets (general+ortho+gynae)', pr:45000, m:1, qf:(b,ot)=>ot},
 {id:'h_mayo', dp:'ot', nm:'Mayo trolley + instrument trolleys (set)', pr:14000, m:1, qf:(b,ot)=>ot},
 {id:'h_scrub', dp:'ot', nm:'Scrub station, 2-bay SS', pr:85000, m:1, qf:(b,ot)=>C(ot/2)},
 {id:'h_recovery', dp:'ot', nm:'Recovery beds (post-op)', pr:22000, m:1, qf:(b,ot)=>ot*2},
 {id:'h_otstools', dp:'ot', nm:'OT stools + kick buckets, SS (set)', pr:6500, m:1, qf:(b,ot)=>ot},
 {id:'h_labour', dp:'mat', nm:'Labour table, telescopic SS', pr:45000, m:1, qf:b=>C(b/50)},
 {id:'h_warmer', dp:'mat', nm:'Baby warmer / resuscitaire', pr:45000, m:1, qf:b=>C(b/50)+1},
 {id:'h_ctg', dp:'mat', nm:'Foetal monitor (CTG)', pr:95000, m:0, qf:b=>C(b/50)},
 {id:'h_delset', dp:'mat', nm:'Delivery instrument sets', pr:12000, m:1, qf:b=>C(b/50)*2},
 {id:'h_cot', dp:'mat', nm:'Baby cot, SS with basket', pr:6500, m:1, qf:b=>C(b/20,2)},
 {id:'h_incub', dp:'nicu', nm:'Infant incubator', pr:185000, m:0, qf:b=>C(b/40,2)},
 {id:'h_photo', dp:'nicu', nm:'Phototherapy unit, LED', pr:35000, m:0, qf:b=>C(b/40,2)},
 {id:'h_cpap', dp:'nicu', nm:'Bubble CPAP system', pr:145000, m:0, qf:b=>C(b/80,1)},
 {id:'h_nicusyr', dp:'nicu', nm:'Syringe pumps (NICU)', pr:28000, m:0, qf:b=>C(b/25,2)},
 {id:'h_opdroom', dp:'opd', nm:'Consultation room set (table+chair+exam table+stool)', pr:22800, m:1, qf:b=>R(b/12,2)},
 {id:'h_opdwait', dp:'opd', nm:'Waiting chairs, 3-seater SS', pr:8500, m:1, qf:b=>R(b/12,2)*2},
 {id:'h_opdrecep', dp:'opd', nm:'Reception + registration counter', pr:35000, m:1, qf:b=>1},
 {id:'h_opdbp', dp:'opd', nm:'BP apparatus + diagnostic set per room', pr:4500, m:0, qf:b=>R(b/12,2)},
 {id:'h_xray', dp:'rad', nm:'X-ray machine (300 mA / 500 mA HF for 100+)', pr:450000, m:0, qf:b=>1, prf:b=>b>=100?850000:450000},
 {id:'h_usg', dp:'rad', nm:'Ultrasound machine (PNDT applies)', pr:650000, m:0, qf:b=>C(b/150,1)},
 {id:'h_ct', dp:'rad', nm:'CT scanner, 16-slice (refurb) — optional', pr:9000000, m:0, qf:b=>b>=200?1:0},
 {id:'h_lead', dp:'rad', nm:'Lead aprons + radiation safety kit', pr:25000, m:0, qf:b=>1},
 {id:'h_radtable', dp:'rad', nm:'X-ray table + cassette trolley', pr:45000, m:1, qf:b=>1},
 {id:'h_biochem', dp:'lab', nm:'Biochemistry analyzer (auto for 100+)', pr:185000, m:0, qf:b=>1, prf:b=>b>=100?850000:185000},
 {id:'h_hema', dp:'lab', nm:'Hematology analyzer, 3-part', pr:285000, m:0, qf:b=>1},
 {id:'h_micro', dp:'lab', nm:'Binocular microscope', pr:28000, m:0, qf:b=>C(b/150,1)},
 {id:'h_fuge', dp:'lab', nm:'Centrifuge, 8-tube', pr:9000, m:0, qf:b=>2},
 {id:'h_labfridge', dp:'lab', nm:'Laboratory refrigerator', pr:35000, m:0, qf:b=>1},
 {id:'h_labtable', dp:'lab', nm:'Lab work tables + phlebotomy chair, SS', pr:28000, m:1, qf:b=>1},
 {id:'h_hautoclave', dp:'cssd', nm:'Horizontal autoclave, high-pressure', pr:350000, m:1, qf:(b,ot)=>C(ot/3,1)},
 {id:'h_eto', dp:'cssd', nm:'ETO sterilizer', pr:450000, m:0, qf:b=>b>=100?1:0},
 {id:'h_cssdtable', dp:'cssd', nm:'CSSD work tables + racks, SS', pr:18000, m:1, qf:b=>2},
 {id:'h_drums', dp:'cssd', nm:'Dressing drums, assorted (set of 6)', pr:6500, m:1, qf:b=>C(b/50,1)},
 {id:'h_dialysis', dp:'dia', nm:'Dialysis machine', pr:550000, m:0, qf:b=>R(b/25,2)},
 {id:'h_ro', dp:'dia', nm:'RO water plant for dialysis', pr:450000, m:0, qf:b=>1},
 {id:'h_diabed', dp:'dia', nm:'Dialysis bed / chair', pr:45000, m:1, qf:b=>R(b/25,2)},
 {id:'h_bbfridge', dp:'bb', nm:'Blood bank refrigerator', pr:185000, m:0, qf:b=>1},
 {id:'h_plasma', dp:'bb', nm:'Plasma freezer (−40°C)', pr:285000, m:0, qf:b=>1},
 {id:'h_donor', dp:'bb', nm:'Blood donor couch', pr:35000, m:1, qf:b=>2},
 {id:'h_phpkg', dp:'phy', nm:'Physio package (tables, IFT, US, TENS, parallel bars)', pr:90000, m:1, qf:b=>1},
 {id:'h_food', dp:'sup', nm:'Food distribution trolley, SS', pr:22000, m:1, qf:b=>C(b/40,2)},
 {id:'h_linen', dp:'sup', nm:'Linen change trolley', pr:12000, m:1, qf:b=>C(b/40,2)},
 {id:'h_washer', dp:'sup', nm:'Laundry washer-extractor, 30 kg', pr:450000, m:0, qf:b=>b>=50?1:0},
 {id:'h_mort', dp:'sup', nm:'Mortuary chamber, 2-body', pr:285000, m:0, qf:b=>C(b/150,1)},
 {id:'h_bins', dp:'sup', nm:'BMW colour-coded bin stations (set of 4)', pr:3200, m:1, qf:b=>C(b/10,3)},
];

/* =========================================================
   MEDICAL COLLEGE DATA — NMC MSR-2023 indicative norms
========================================================= */
const SEATS = [50,100,150,200,250];
const CBEDS = {50:220, 100:420, 150:605, 200:750, 250:900};   // indicative — verify current NMC MSR
const COTS  = {50:5, 100:7, 150:9, 200:10, 250:12};

const CDEPTS = [
 {id:'anat',  ico:'🦴', nm:'Anatomy & dissection hall'},
 {id:'labs',  ico:'🔬', nm:'Teaching labs (Physio·Biochem·Path·Micro·Pharma)'},
 {id:'lt',    ico:'🪑', nm:'Lecture theatres & exam hall'},
 {id:'skill', ico:'🧍', nm:'Skill & simulation lab'},
 {id:'lib',   ico:'📚', nm:'Central library'},
 {id:'hostel',ico:'🛏️', nm:'Hostels & mess (students + interns)'},
 {id:'admin', ico:'🏛️', nm:'Faculty & administration'},
];

const CITEMS = [
 {id:'c_dissect', dp:'anat', nm:'Dissection table, SS with drainage', pr:45000, m:1, qf:s=>C(s/10)},
 {id:'c_cadaver', dp:'anat', nm:'Cadaver cold storage chamber, 6-body', pr:450000, m:0, qf:s=>C(s/100)},
 {id:'c_skel', dp:'anat', nm:'Articulated skeleton + bone set', pr:35000, m:0, qf:s=>C(s/25)},
 {id:'c_anatmus', dp:'anat', nm:'Museum display cabinets, glass', pr:18000, m:1, qf:s=>C(s/10)},
 {id:'c_micro', dp:'labs', nm:'Binocular microscope (student)', pr:28000, m:0, qf:s=>C(s*0.6)},
 {id:'c_bench', dp:'labs', nm:'Lab work bench with reagent rack', pr:22000, m:1, qf:s=>C(s/4)},
 {id:'c_stool', dp:'labs', nm:'Lab stool, SS', pr:1200, m:1, qf:s=>s*2},
 {id:'c_labequip', dp:'labs', nm:'Dept lab equipment set (centrifuge, incubator, water bath, colorimeter)', pr:185000, m:0, qf:s=>C(s/50)},
 {id:'c_demob', dp:'labs', nm:'Demo room bench, 3-seater', pr:6500, m:1, qf:s=>C(s/2.5)},
 {id:'c_ltseat', dp:'lt', nm:'Lecture theatre gallery seating (per seat, 4 LTs)', pr:4500, m:1, qf:s=>s*4},
 {id:'c_av', dp:'lt', nm:'LT podium + AV system', pr:185000, m:0, qf:s=>4},
 {id:'c_exam', dp:'lt', nm:'Examination hall desk + chair', pr:3500, m:1, qf:s=>C(s*1.2)},
 {id:'c_skillbed', dp:'skill', nm:'Skill lab hospital beds + exam couches', pr:16500, m:1, qf:s=>4},
 {id:'c_bls', dp:'skill', nm:'BLS/ALS manikin set', pr:250000, m:0, qf:s=>C(s/150)},
 {id:'c_sim', dp:'skill', nm:'Clinical trainers set (delivery, IV arm, intubation)', pr:350000, m:0, qf:s=>1},
 {id:'c_libtable', dp:'lib', nm:'Library reading table, 4-seater + chairs', pr:18000, m:1, qf:s=>C(s/8)},
 {id:'c_rack', dp:'lib', nm:'Book rack, steel double-sided', pr:8500, m:1, qf:s=>C(s/5)},
 {id:'c_hostel', dp:'hostel', nm:'Hostel set (cot + mattress + study table + chair + almirah)', pr:28000, m:1, qf:s=>C(s*4.5)},
 {id:'c_dining', dp:'hostel', nm:'Mess dining set, 8-seater with benches', pr:22000, m:1, qf:s=>C(s*4.5/16)},
 {id:'c_fac', dp:'admin', nm:'Faculty cabin furniture set', pr:25000, m:1, qf:s=>C(s*0.85)},
 {id:'c_council', dp:'admin', nm:'Seminar / council room set', pr:150000, m:1, qf:s=>2},
];

/* =========================================================
   MEDSOR SERVICES — tie-ups, AMC/CMC, repair
========================================================= */
const SERVICES = [
 {id:'tieup', ico:'🤝', tl:'Corporate / chain hospital tie-up', td:'Annual rate contract for corporate hospitals & hospital chains — locked factory pricing, priority manufacturing slots, dedicated account manager, multi-site delivery across India.', pf:()=>'Custom rate contract — negotiated on annual volume'},
 {id:'amc', ico:'🛠️', tl:'AMC — Annual Maintenance Contract', td:'Scheduled preventive maintenance visits for beds, OT tables, trolleys, furniture & equipment. Labour included, spare parts charged at actuals.', pf:(t)=>{const v=Math.max(Math.round(t*0.04),15000); return 'Est. '+fmtBig(v)+'/year (~4% of your selected equipment value · indicative, final as per scope)';}},
 {id:'cmc', ico:'🔧', tl:'CMC — Comprehensive Maintenance Contract', td:'All-inclusive cover: labour + spare parts + breakdown call-outs. Zero surprise costs, maximum uptime.', pf:(t)=>{const v=Math.max(Math.round(t*0.07),25000); return 'Est. '+fmtBig(v)+'/year (~7% of your selected equipment value · indicative, final as per equipment list & usage)';}},
 {id:'repair', ico:'🏗️', tl:'Hospital repair & refurbishment work', td:'As-per-need repair of old beds, OT tables, stretchers & trolleys. Indicative rates: hydraulic pump repair ₹2,500–6,500/unit · re-powder coating ₹2,000–3,500/bed · upholstery ₹1,200–2,500/unit · castor set (4 pc) ₹800–2,000 · OT table overhaul ₹8,000–18,000. Final rates after free inspection (Delhi-NCR).', pf:()=>'Per-job rates above — site inspection free in Delhi-NCR'},
 {id:'buyback', ico:'♻️', tl:'Buyback / exchange — sell us your old equipment', td:'Upgrading? We take back your old beds, OT tables, trolleys & furniture — fair valuation after inspection, instant exchange bonus on new Medsor purchases. We refurbish and recirculate, so nothing goes to scrap. The complete eco cycle: Buy new → AMC/CMC → Repair → Buyback → Refurbish → Reuse. Buyback currently serviced in Delhi-NCR &amp; North India; other regions via our dealer network, subject to logistics feasibility.', pf:()=>'Valuation after free inspection · exchange bonus on new purchase'},
];

/* =========================================================
   LICENCES — md: both | hosp (hosp+college) | college
========================================================= */
const LICENCES = [
 {id:'nmclop', nm:'NMC Letter of Permission (LOP) + Essentiality Certificate', dt:'Essentiality Certificate & Consent of Affiliation from State Govt, then LOP from NMC under MSR-2023. Annual renewal until recognition. The single most critical approval for a medical college.', auth:'NMC / State Govt', time:'12–24 months', md:'college'},
 {id:'univaff', nm:'University affiliation', dt:'Affiliation with the state health sciences university for the MBBS programme.', auth:'State Health University', time:'3–6 months', md:'college'},
 {id:'nmc', nm:'Doctor registration — NMC + State Medical Council', dt:'Registration with the state council where you practise. Display certificate in clinic.', auth:'State Medical Council', time:'Already held / transfer 2–4 wks', md:'both'},
 {id:'cea', nm:'Establishment registration — Clinical Establishments Act / State Act', dt:'Mandatory registration of the establishment. In Delhi: DGHS registration. Provisional first, then permanent. Hospitals need bed-strength declaration.', auth:'DGHS / District Health Office', time:'2–8 weeks', md:'both'},
 {id:'bmw', nm:'Biomedical Waste Authorization', dt:'Authorization from Pollution Control Board + agreement with CBWTF for daily pickup. Bedded hospitals are scrutinised closely.', auth:'SPCB / DPCC', time:'3–6 weeks', md:'both'},
 {id:'cte', nm:'Pollution consents — Consent to Establish & Operate', dt:'CTE before construction/fit-out, CTO before operations. Covers ETP/STP requirements (mandatory for bedded facilities).', auth:'SPCB / DPCC', time:'6–12 weeks', md:'hosp'},
 {id:'fire', nm:'Fire NOC', dt:'Mandatory for hospitals & colleges. Sprinklers, hydrants, smoke detection, evacuation plan as per NBC. Clinics: depends on area.', auth:'State Fire Service', time:'4–10 weeks', md:'both'},
 {id:'building', nm:'Building sanction + Occupancy certificate', dt:'Sanctioned plan with correct land use + OC before operations. Critical — many projects get stuck here.', auth:'Municipal Corp / Dev Authority', time:'Varies', md:'hosp'},
 {id:'trade', nm:'Trade / health trade licence', dt:'From your municipal body (MCD in Delhi) for running the premises.', auth:'Municipal Corporation', time:'2–4 weeks', md:'both'},
 {id:'shops', nm:'Shops & Establishment registration', dt:'Required for employed staff. Online in most states.', auth:'State Labour Dept', time:'1 week', md:'both'},
 {id:'drug', nm:'Drug licence (Form 20/21) — pharmacy', dt:'To stock & sell medicines. Registered pharmacist + premises norms. Hospital pharmacy is effectively mandatory for bedded facilities.', auth:'State Drug Control', time:'4–8 weeks', md:'hosp', ad:'pharmacy'},
 {id:'pndt', nm:'PC-PNDT registration — ultrasound', dt:'Mandatory BEFORE installing ANY ultrasound machine. Heavy penalties. Form F record-keeping for obstetric scans.', auth:'District Appropriate Authority', time:'4–8 weeks', md:'hosp', sp:['gynae'], dp:'rad'},
 {id:'aerb', nm:'AERB licence — X-ray / CT', dt:'eLORA registration for each radiology unit + RSO designation + TLD badges for staff. CT needs site approval first.', auth:'AERB (eLORA portal)', time:'4–12 weeks', md:'hosp', sp:['dental','ortho'], dp:'rad'},
 {id:'bblic', nm:'Blood bank / blood centre licence', dt:'CDSCO + State Drug Control joint licence. Qualified medical officer & technicians, equipment validation required. Mandatory for teaching hospitals.', auth:'CDSCO / SLA', time:'3–6 months', md:'hosp', dp:'bb'},
 {id:'narc', nm:'Narcotics (NDPS) possession licence', dt:'For morphine/fentanyl & scheduled drugs in ICU/OT/palliative use. Record-keeping under NDPS rules.', auth:'State Drug Control', time:'4–8 weeks', md:'hosp'},
 {id:'lift', nm:'Lift licence', dt:'Per-lift erection permission + operating licence with annual renewal. Hospitals need stretcher-size lifts.', auth:'State Electrical Inspectorate', time:'4–8 weeks', md:'hosp'},
 {id:'dg', nm:'DG set & electrical approvals', dt:'CEIG approval for HT connection/transformer + DG set noise & emission norms. 100% power backup expected for licensing.', auth:'CEIG / DISCOM', time:'4–8 weeks', md:'hosp'},
 {id:'fssai', nm:'FSSAI licence — kitchen / mess', dt:'Required for in-house patient catering, canteen & hostel mess.', auth:'FSSAI', time:'2–4 weeks', md:'hosp', dp:'sup'},
 {id:'amb', nm:'Ambulance registration & permits', dt:'Vehicle registered as ambulance + road tax exemption + equipment as per category (BLS/ALS).', auth:'RTO / Transport Dept', time:'2–4 weeks', md:'hosp'},
 {id:'gst', nm:'GST registration', dt:'Healthcare services exempt, but needed for medicine sales, taxable room rent, canteen etc.', auth:'GST Portal', time:'1 week', md:'both'},
 {id:'pan', nm:'Entity PAN, current account & Udyam (MSME)', dt:'Current account in entity name; Udyam unlocks MSME benefits & easier equipment loans.', auth:'Bank / Udyam portal', time:'1 week', md:'both'},
 {id:'indem', nm:'Professional indemnity + facility insurance', dt:'Indemnity for doctors + public liability + fire/asset cover.', auth:'Any general insurer', time:'1 week', md:'both'},
 {id:'nabh', nm:'NABH entry-level (optional, recommended)', dt:'Better insurance empanelment (CGHS/ECHS/TPA rates) and credibility. Plan from day one.', auth:'NABH / QCI', time:'6–12 months', md:'hosp'},
 {id:'sign', nm:'Signboard & display compliance', dt:'Name board with registration number; display of registration, doctor list, fee schedule & BMW segregation chart.', auth:'Self / SMC norms', time:'1 week', md:'both'},
];

/* ================= STATE ================= */
let S = {mode:'clinic', spec:'gp', addons:{}, items:{},
         beds:100, depts:null, hitems:{},
         seats:100, cdepts:null, chitems:{}, citems:{},
         services:{}, custom:[], lic:{}, lead:null};

const curBeds = () => S.mode==='college' ? CBEDS[S.seats] : S.beds;
const curOT   = () => S.mode==='college' ? COTS[S.seats] : otCount(S.beds);

function defaultsClinic(){
  ITEMS.forEach(it=>{
    if(S.items[it.id]) return;
    const active = it.common || (it.sp && it.sp.includes(S.spec)) || (it.ad && S.addons[it.ad]);
    if(active) S.items[it.id] = {on: it.def>0, q: Math.max(it.def,1)};
  });
}
function defaultsHosp(reset){
  if(!S.depts || reset){
    S.depts = {};
    DEPTS.forEach(d=>{ S.depts[d.id] = d.minB<=S.beds && d.def(S.beds); });
  }
  if(reset) S.hitems = {};
  const ot = otCount(S.beds);
  HITEMS.forEach(it=>{
    if(S.hitems[it.id]) return;
    const q = it.qf(S.beds, ot);
    S.hitems[it.id] = {on: q>0, q: Math.max(q,1)};
  });
}
function defaultsCollege(reset){
  if(!S.cdepts || reset){
    S.cdepts = {}; CDEPTS.forEach(d=>S.cdepts[d.id]=true);
  }
  if(reset){ S.chitems = {}; S.citems = {}; }
  const b = CBEDS[S.seats], ot = COTS[S.seats];
  HITEMS.forEach(it=>{
    if(S.chitems[it.id]) return;
    const q = it.qf(b, ot);
    S.chitems[it.id] = {on: q>0, q: Math.max(q,1)};
  });
  CITEMS.forEach(it=>{
    if(S.citems[it.id]) return;
    const q = it.qf(S.seats);
    S.citems[it.id] = {on: q>0, q: Math.max(q,1)};
  });
}
function hPrice(it){ return it.prf ? it.prf(curBeds()) : it.pr; }

function activeClinicItems(){ return ITEMS.filter(it=> it.common || (it.sp && it.sp.includes(S.spec)) || (it.ad && S.addons[it.ad])); }

function selTotal(){
  let t=0,c=0;
  if(S.mode==='clinic'){
    activeClinicItems().forEach(it=>{const s=S.items[it.id]; if(s&&s.on){t+=it.pr*s.q;c++;}});
  }else if(S.mode==='hosp'){
    HITEMS.forEach(it=>{ if(S.depts&&S.depts[it.dp]){const s=S.hitems[it.id]; if(s&&s.on){t+=hPrice(it)*s.q;c++;}}});
  }else{
    HITEMS.forEach(it=>{const s=S.chitems[it.id]; if(s&&s.on){t+=hPrice(it)*s.q;c++;}});
    CITEMS.forEach(it=>{ if(S.cdepts&&S.cdepts[it.dp]){const s=S.citems[it.id]; if(s&&s.on){t+=it.pr*s.q;c++;}}});
  }
  (S.custom||[]).filter(x=>x.md===S.mode).forEach(x=>{ t+=x.pr*x.q; c++; });
  return {t,c};
}
const fmt = n => '₹' + n.toLocaleString('en-IN');
const fmtBig = n => n>=1e7 ? '₹'+(n/1e7).toFixed(2)+' Cr' : n>=1e5 ? '₹'+(n/1e5).toFixed(1)+' L' : fmt(n);
const esc = x => String(x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
const rnd = n => n>=10000 ? Math.round(n/500)*500 : Math.round(n/50)*50;
const fmtRange = p => fmt(rnd(p*0.93))+'–'+fmt(rnd(p*1.12));

/* ================= RENDER ================= */
function renderMode(){
  document.getElementById('mode-clinic').className = 'mode'+(S.mode==='clinic'?' sel-c':'');
  document.getElementById('mode-hosp').className = 'mode'+(S.mode==='hosp'?' sel-h':'');
  document.getElementById('mode-college').className = 'mode'+(S.mode==='college'?' sel-g':'');
  document.getElementById('clinicSetup').style.display = S.mode==='clinic'?'block':'none';
  document.getElementById('hospSetup').style.display = S.mode==='hosp'?'block':'none';
  document.getElementById('collSetup').style.display = S.mode==='college'?'block':'none';
  document.body.classList.toggle('hmode', S.mode==='hosp');
  document.body.classList.toggle('cmode', S.mode==='college');
  document.getElementById('hdTitle').textContent = S.mode==='hosp'?'Hospital Project Planner': S.mode==='college'?'Medical College Planner':'Clinic Starter Kit';
}
function renderSpecs(){
  document.getElementById('specGrid').innerHTML = SPECIALTIES.map(s=>
   `<div class="spec ${S.spec===s.id?'sel':''}" onclick="pickSpec('${s.id}')">
      <div class="ico">${s.ico}</div><div class="nm">${s.nm}</div><div class="ct">${s.ct}</div>
    </div>`).join('');
}
function renderAddons(){
  document.getElementById('addonCard').innerHTML = ADDONS.map(a=>
   `<div class="tog-row">
      <div><div class="tl">${a.tl}</div><div class="td">${a.td}</div></div>
      <label class="switch"><input type="checkbox" ${S.addons[a.id]?'checked':''} onchange="togAddon('${a.id}',this.checked)"><span class="slider"></span></label>
    </div>`).join('');
}
function renderBeds(){
  document.getElementById('bedChips').innerHTML = BEDS.map(b=>
   `<div class="chip ${S.beds===b?'sel':''}" onclick="pickBeds(${b})">${b}<span class="s">beds</span></div>`).join('');
  const ot = otCount(S.beds);
  document.getElementById('bedInfo').innerHTML =
   `<b>${S.beds}-bed multispecialty:</b> ~${Math.ceil(S.beds*0.55)} ward beds · ${Math.max(2,Math.round(S.beds*0.12))} ICU beds · ${ot} OT${ot>1?'s':''} · ${Math.max(2,Math.round(S.beds/12))} OPD rooms · ${Math.max(2,Math.round(S.beds*0.05))} casualty beds`;
}
function renderSeats(){
  document.getElementById('seatChips').innerHTML = SEATS.map(s=>
   `<div class="chip ${S.seats===s?'sel':''}" onclick="pickSeats(${s})">${s}<span class="s">MBBS seats</span></div>`).join('');
  const b = CBEDS[S.seats], ot = COTS[S.seats];
  document.getElementById('seatInfo').innerHTML =
   `<b>${S.seats}-seat college:</b> ${b}-bed teaching hospital (indicative NMC norm) · ${ot} OTs · hostels for ~${Math.ceil(S.seats*4.5)} students &amp; interns · 4 lecture theatres · dissection hall for ${S.seats}/batch`;
}
function renderDepts(){
  document.getElementById('deptCard').innerHTML = DEPTS.map(d=>{
    const locked = d.minB > S.beds;
    return `<div class="tog-row" style="${locked?'opacity:.4':''}">
      <div><div class="tl">${d.ico} ${d.nm}</div><div class="td">${locked?'Recommended for '+d.minB+'+ beds':''}</div></div>
      <label class="switch"><input type="checkbox" ${S.depts&&S.depts[d.id]?'checked':''} ${locked?'disabled':''} onchange="togDept('${d.id}',this.checked)"><span class="slider"></span></label>
    </div>`;
  }).join('');
}
function renderCdepts(){
  document.getElementById('cdeptCard').innerHTML = CDEPTS.map(d=>
   `<div class="tog-row">
      <div><div class="tl">${d.ico} ${d.nm}</div></div>
      <label class="switch"><input type="checkbox" ${S.cdepts&&S.cdepts[d.id]?'checked':''} onchange="togCdept('${d.id}',this.checked)"><span class="slider"></span></label>
    </div>`).join('');
}
function renderEquip(){
  let html='';
  if(S.mode==='clinic'){
    const list = activeClinicItems(); const byCat={};
    list.forEach(it=>{(byCat[it.cat]=byCat[it.cat]||[]).push(it)});
    ['F','S','D','X','A'].forEach(c=>{
      if(!byCat[c]) return;
      let ct=0; byCat[c].forEach(it=>{const s=S.items[it.id]; if(s&&s.on) ct+=it.pr*s.q;});
      html += `<div class="cat-head"><h3>${CATS[c]}</h3><span class="ctotal">~${fmtBig(ct)}</span></div>`;
      html += byCat[c].map(it=>rowHTML(it, S.items[it.id], it.pr, 'c')).join('');
    });
  }else if(S.mode==='hosp'){
    html += hospBlockHTML(S.hitems, 'h', d=>S.depts&&S.depts[d.id]);
  }else{
    html += `<div class="block-head">🏥 Teaching Hospital — ${CBEDS[S.seats]} beds</div>`;
    html += hospBlockHTML(S.chitems, 'ch', d=>true);
    html += `<div class="block-head">🎓 College Block — ${S.seats} MBBS seats</div>`;
    CDEPTS.forEach(d=>{
      if(!S.cdepts||!S.cdepts[d.id]) return;
      const its = CITEMS.filter(it=>it.dp===d.id);
      let ct=0; its.forEach(it=>{const s=S.citems[it.id]; if(s&&s.on) ct+=it.pr*s.q;});
      html += `<div class="cat-head"><h3>${d.ico} ${d.nm}</h3><span class="ctotal">~${fmtBig(ct)}</span></div>`;
      html += its.map(it=>rowHTML(it, S.citems[it.id], it.pr, 'cl')).join('');
    });
  }
  document.getElementById('equipList').innerHTML = html;
}
function hospBlockHTML(store, k, deptOn){
  let html='';
  DEPTS.forEach(d=>{
    if(!deptOn(d)) return;
    const its = HITEMS.filter(it=>it.dp===d.id);
    let ct=0; its.forEach(it=>{const s=store[it.id]; if(s&&s.on) ct+=hPrice(it)*s.q;});
    html += `<div class="cat-head"><h3>${d.ico} ${d.nm}</h3><span class="ctotal">~${fmtBig(ct)}</span></div>`;
    html += its.map(it=>rowHTML(it, store[it.id], hPrice(it), k)).join('');
  });
  return html;
}
function rowHTML(it, s, price, k){
  s = s||{on:false,q:1};
  return `<div class="item ${s.on?'on':'off'}">
    <div class="chk" onclick="togItem('${it.id}','${k}')"></div>
    <div class="info">
      <div class="nm">${it.nm} <span class="tag ${it.m?'medsor':'third'}">${it.m?'MEDSOR':'3RD PARTY'}</span></div>
      <div class="meta">${fmtRange(price)} each (est.)</div>
    </div>
    <div class="qty"><button onclick="qty('${it.id}',-1,'${k}')">−</button><input type="number" inputmode="numeric" min="1" max="99999" value="${s.q}" onchange="qtySet('${it.id}',this.value,'${k}')"><button onclick="qty('${it.id}',1,'${k}')">+</button></div>
    <div class="pr">${s.on?'~'+fmtBig(price*s.q):'—'}</div>
  </div>`;
}
function activeLics(){
  return LICENCES.filter(l=>{
    if(l.md==='college') return S.mode==='college';
    if(S.mode==='clinic'){
      if(l.md==='hosp'){ return (l.sp&&l.sp.includes(S.spec)) || (l.ad&&S.addons[l.ad]); }
      return true;
    }
    /* hosp & college */
    if(l.dp){
      if(S.mode==='college') return true; /* teaching hospital has all depts */
      return S.depts && S.depts[l.dp];
    }
    return true;
  });
}
function renderLic(){
  const list = activeLics();
  document.getElementById('licList').innerHTML = list.map(l=>
   `<div class="lic ${S.lic[l.id]?'done':''}" onclick="togLic('${l.id}')">
      <div class="chk"></div>
      <div><div class="nm">${l.nm}</div><div class="dt">${l.dt}</div>
      <span class="auth">${l.auth}</span><span class="time">⏱ ${l.time}</span></div>
    </div>`).join('');
  const done = list.filter(l=>S.lic[l.id]).length;
  document.getElementById('licProg').textContent = `${done} of ${list.length} done`;
  document.getElementById('licBar').style.width = (list.length?100*done/list.length:0)+'%';
}
function renderSummary(){
  const {t,c} = selTotal();
  let label, medsorT=0, breakRows='';
  function addDeptRows(store, deptOn){
    DEPTS.forEach(d=>{
      if(!deptOn(d)) return;
      let dt=0;
      HITEMS.filter(it=>it.dp===d.id).forEach(it=>{const s=store[it.id]; if(s&&s.on){dt+=hPrice(it)*s.q; if(it.m)medsorT+=hPrice(it)*s.q;}});
      if(dt) breakRows+=`<div class="sum-row"><span>${d.ico} ${d.nm}</span><b>${fmtBig(dt)}</b></div>`;
    });
  }
  if(S.mode==='clinic'){
    label = SPECIALTIES.find(s=>s.id===S.spec).nm + ' clinic setup';
    const byCat={};
    activeClinicItems().forEach(it=>{const s=S.items[it.id]; if(s&&s.on){byCat[it.cat]=(byCat[it.cat]||0)+it.pr*s.q; if(it.m)medsorT+=it.pr*s.q;}});
    ['F','S','D','X','A'].forEach(cc=>{ if(byCat[cc]) breakRows+=`<div class="sum-row"><span>${CATS[cc]}</span><b>${fmtBig(byCat[cc])}</b></div>`; });
  }else if(S.mode==='hosp'){
    label = S.beds + '-bed Multispecialty Hospital';
    addDeptRows(S.hitems, d=>S.depts&&S.depts[d.id]);
  }else{
    label = S.seats + '-seat Medical College + ' + CBEDS[S.seats] + '-bed Teaching Hospital';
    addDeptRows(S.chitems, d=>true);
    CDEPTS.forEach(d=>{
      if(!S.cdepts||!S.cdepts[d.id]) return;
      let dt=0;
      CITEMS.filter(it=>it.dp===d.id).forEach(it=>{const s=S.citems[it.id]; if(s&&s.on){dt+=it.pr*s.q; if(it.m)medsorT+=it.pr*s.q;}});
      if(dt) breakRows+=`<div class="sum-row"><span>${d.ico} ${d.nm}</span><b>${fmtBig(dt)}</b></div>`;
    });
  }
  document.getElementById('sumSpec').textContent = label;
  document.getElementById('sumTotal').textContent = '~'+fmtBig(t);
  document.getElementById('sumRange').innerHTML = `${fmt(t)} · ${c} line items · realistic range ${fmtBig(Math.round(t*0.9))} – ${fmtBig(Math.round(t*1.15))} (ex-GST, ex-freight). Equipment &amp; furniture only — excludes civil work, MGPS/oxygen piping, HVAC, modular OT interiors, IT. College norms are indicative — verify current NMC MSR.`;
  const lics = activeLics(); const done = lics.filter(l=>S.lic[l.id]).length;
  breakRows += `<div class="sum-row"><span>Supplied by Medsor direct <span class="sml">(one PO, one delivery, factory rates)</span></span><b style="color:var(--primary)">${fmtBig(medsorT)}</b></div>`;
  breakRows += `<div class="sum-row"><span>Licence checklist</span><b>${done}/${lics.length} done</b></div>`;
  document.getElementById('sumBreak').innerHTML = breakRows;
  const lb = document.getElementById('leadBadge');
  if(S.lead && S.lead.verified){
    lb.style.display='block';
    lb.innerHTML = `✅ Verified: <b>${esc(S.lead.name)}</b> (${esc(S.lead.degree)}) · ${esc(S.lead.city)} · ${esc(S.lead.phone)}`;
  } else lb.style.display='none';
}
function renderPill(){
  const {t,c} = selTotal();
  document.getElementById('pillTotal').textContent = '~'+fmtBig(t);
  document.getElementById('pillCount').textContent = c + ' items';
  renderServices();
}
function renderServices(){
  const {t} = selTotal();
  const rows = SERVICES.map(s=>
   `<div class="tog-row">
      <div><div class="tl">${s.ico} ${s.tl}</div><div class="td">${s.td}</div>
      <div class="td" style="color:var(--primary);font-weight:700;margin-top:4px">💰 ${s.pf(t)}</div></div>
      <label class="switch"><input type="checkbox" ${S.services&&S.services[s.id]?'checked':''} onchange="togService('${s.id}',this.checked)"><span class="slider"></span></label>
    </div>`).join('');
  ['svcCard','svcCardSetup'].forEach(id=>{const e=document.getElementById(id); if(e) e.innerHTML=rows;});
}
function togService(id,v){ if(!S.services) S.services={}; S.services[id]=v; saveState(); renderServices(); }

/* ===== CUSTOM PRODUCTS ===== */
function myCustom(){ return (S.custom||[]).filter(c=>c.md===S.mode); }
function addCustom(){
  const nm=document.getElementById('cu_nm').value.trim();
  const spec=document.getElementById('cu_spec').value.trim();
  const q=Math.max(1,parseInt(document.getElementById('cu_q').value,10)||1);
  const pr=Math.max(0,parseInt(document.getElementById('cu_pr').value,10)||0);
  if(nm.length<2){ alert('Please enter the product name.'); return; }
  if(!S.custom) S.custom=[];
  S.custom.push({nm, spec, q, pr, md:S.mode});
  document.getElementById('cu_nm').value=''; document.getElementById('cu_spec').value='';
  document.getElementById('cu_q').value=1; document.getElementById('cu_pr').value='';
  saveState(); renderCustom(); renderSummary(); renderPill();
}
function cuDel(i){ S.custom.splice(S.custom.indexOf(myCustom()[i]),1); saveState(); renderCustom(); renderSummary(); renderPill(); }
function cuQtySet(i,val){ const c=myCustom()[i]; const n=parseInt(val,10); c.q=(isNaN(n)||n<1)?1:Math.min(n,99999); saveState(); renderCustom(); renderSummary(); renderPill(); }
function renderCustom(){
  const list = myCustom();
  const e=document.getElementById('customList'); if(!e) return;
  if(!list.length){ e.innerHTML=''; return; }
  let ct=0; list.forEach(c=>ct+=c.pr*c.q);
  e.innerHTML = `<div class="cat-head"><h3>📝 Your custom items</h3><span class="ctotal">${ct?fmtBig(ct):'price on request'}</span></div>` +
   list.map((c,i)=>`<div class="item on">
      <div class="chk" onclick="cuDel(${i})" style="background:#C24A3A;border-color:#C24A3A"><span style="color:#fff;font-weight:800;font-size:.8rem">✕</span></div>
      <div class="info"><div class="nm">${esc(c.nm)}</div>
      <div class="meta">${c.spec?esc(c.spec)+' · ':''}${c.pr?fmt(c.pr)+' each':'price on request'}</div></div>
      <div class="qty"><input type="number" inputmode="numeric" min="1" value="${c.q}" onchange="cuQtySet(${i},this.value)"></div>
      <div class="pr">${c.pr?fmtBig(c.pr*c.q):'—'}</div>
    </div>`).join('');
}

/* ===== ENGINEER REGISTRATION ===== */
function engOpen(){ document.getElementById('engGate').classList.add('open'); }
function engSubmit(){
  const name=document.getElementById('e_name').value.trim();
  const city=document.getElementById('e_city').value.trim();
  const phone=document.getElementById('e_phone').value.trim();
  const email=document.getElementById('e_email').value.trim();
  const exp=document.getElementById('e_exp').value;
  const skills=[...document.querySelectorAll('#e_skills input:checked')].map(c=>c.value);
  const ok = name.length>2 && city.length>2 && /^[6-9]\d{9}$/.test(phone) && exp && skills.length>0;
  document.getElementById('eerr').style.display = ok?'none':'block';
  if(!ok) return;
  const msg = `MEDSOR SERVICE ENGINEER REGISTRATION\n\nName: ${name}\nLocation: ${city}\nMobile: ${phone}\nEmail: ${email||'—'}\nExperience: ${exp}\nSkills: ${skills.join(', ')}\n\nPlease register me for AMC/CMC & repair jobs in my area.`;
  if(OWNER_EMAIL && OWNER_EMAIL.indexOf('REPLACE')!==0){
    fetch('https://formsubmit.co/ajax/'+OWNER_EMAIL,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({_subject:'🔧 Engineer Registration: '+name+' — '+city, Type:'SERVICE ENGINEER', Name:name, Location:city, Mobile:phone, Email:email||'—', Experience:exp, Skills:skills.join(', '), Time:new Date().toISOString()})}).catch(()=>{});
  }
  window.open('https://wa.me/'+OWNER_WHATSAPP+'?text='+encodeURIComponent(msg),'_blank');
  document.getElementById('engGate').classList.remove('open');
  ['e_name','e_city','e_phone','e_email'].forEach(id=>document.getElementById(id).value='');
  document.getElementById('e_exp').value='';
  document.querySelectorAll('#e_skills input').forEach(c=>c.checked=false);
  alert('Thank you '+name+'! Send the WhatsApp message that just opened to complete your registration.');
}
function renderAll(){renderMode();renderSpecs();renderAddons();renderBeds();renderSeats();renderDepts();renderCdepts();renderEquip();renderCustom();renderLic();renderServices();renderSummary();renderPill();}

/* ================= ACTIONS ================= */
function setMode(m){
  S.mode=m;
  if(m==='hosp') defaultsHosp(false);
  else if(m==='college') defaultsCollege(false);
  else defaultsClinic();
  saveState(); renderAll();
}
function pickSpec(id){S.spec=id; defaultsClinic(); saveState(); renderAll();}
function togAddon(id,v){S.addons[id]=v; defaultsClinic(); saveState(); renderAll();}
function pickBeds(b){S.beds=b; defaultsHosp(true); saveState(); renderAll();}
function pickSeats(s){S.seats=s; defaultsCollege(true); saveState(); renderAll();}
function togDept(id,v){S.depts[id]=v; defaultsHosp(false); saveState(); renderAll();}
function togCdept(id,v){S.cdepts[id]=v; saveState(); renderAll();}
function storeFor(k){ return k==='h'?S.hitems : k==='ch'?S.chitems : k==='cl'?S.citems : S.items; }
function togItem(id,k){const st=storeFor(k); st[id].on=!st[id].on; saveState(); renderEquip(); renderSummary(); renderPill();}
function qty(id,d,k){const st=storeFor(k); const s=st[id]; s.q=Math.max(1,s.q+d); if(d>0&&!s.on)s.on=true; saveState(); renderEquip(); renderSummary(); renderPill();}
function qtySet(id,val,k){const st=storeFor(k); const s=st[id]; const n=parseInt(val,10); s.q=(isNaN(n)||n<1)?1:Math.min(n,99999); if(s.q>0&&!s.on)s.on=true; saveState(); renderEquip(); renderSummary(); renderPill();}
function togLic(id){S.lic[id]=!S.lic[id]; saveState(); renderLic(); renderSummary();}
let pendingTab = null;
function goTab(t){
  if((t==='equip'||t==='lic'||t==='sum') && !(S.lead && S.lead.verified)){ pendingTab=t; openGate(); return; }
  document.querySelectorAll('.tab').forEach(e=>e.classList.remove('active'));
  document.querySelectorAll('nav button').forEach(e=>e.classList.remove('act'));
  document.getElementById('tab-'+t).classList.add('active');
  document.getElementById('nav-'+t).classList.add('act');
  window.scrollTo({top:0});
  if(t==='sum') renderSummary();
}

/* ================= LEAD GATE ================= */
function openGate(){
  if(S.lead && !S.lead.verified){ showStep(2); } else { showStep(1); }
  document.getElementById('gate').classList.add('open');
}
function showStep(n){
  document.getElementById('gstep1').classList.toggle('on', n===1);
  document.getElementById('gstep2').classList.toggle('on', n===2);
}
function gateBack(){ showStep(1); }
function gateStep1(){
  if(document.getElementById('g_web').value) return; /* bot honeypot */
  const name=document.getElementById('g_name').value.trim();
  const degree=document.getElementById('g_degree').value;
  const city=document.getElementById('g_city').value.trim();
  const email=document.getElementById('g_email').value.trim();
  const phone=document.getElementById('g_phone').value.trim();
  const pin=document.getElementById('g_pin').value.trim();
  const consent=document.getElementById('g_consent').checked;
  const ok = name.length>2 && degree && city.length>2 && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) && /^[6-9]\d{9}$/.test(phone) && (pin===''||/^\d{6}$/.test(pin)) && consent;
  document.getElementById('gerr1').style.display = ok?'none':'block';
  if(!ok) return;
  const code = String(Math.floor(1000+Math.random()*9000));
  S.lead = {name, degree, city, email, phone, pin, consent:true, code, verified:false, ts:new Date().toISOString()};
  saveState();
  emailLead('NEW LEAD (verification pending)');
  showStep(2);
}
function openWaOtp(){
  const L=S.lead; if(!L) return;
  const msg = `MEDSOR SETUP PLANNER — VERIFICATION\nMy code: ${L.code}\n\nName: ${L.name}\nQualification: ${L.degree}\nLocation: ${L.city}\nEmail: ${L.email}\nMobile: ${L.phone}\nPIN: ${L.pin||'—'}\nProject: ${projectLabel()}`;
  window.open('https://wa.me/'+OWNER_WHATSAPP+'?text='+encodeURIComponent(msg),'_blank');
}
function gateVerify(){
  const v=document.getElementById('g_otp').value.trim();
  if(S.lead && v===S.lead.code){
    S.lead.verified=true; delete S.lead.code; saveState();
    emailLead('VERIFIED LEAD ✅');
    document.getElementById('gate').classList.remove('open');
    document.getElementById('gerr2').style.display='none';
    const pt = pendingTab; pendingTab = null;
    const pa = pendingAction; pendingAction = null;
    if(pt) goTab(pt); else goTab('equip');
    if(pa==='wa') sendWhatsApp();
    else if(pa==='copy') copyList();
  } else {
    document.getElementById('gerr2').style.display='block';
  }
}
function projectLabel(){
  if(S.mode==='clinic') return SPECIALTIES.find(s=>s.id===S.spec).nm+' Clinic';
  if(S.mode==='hosp') return S.beds+'-Bed Multispecialty Hospital';
  return S.seats+'-Seat Medical College + '+CBEDS[S.seats]+'-Bed Teaching Hospital';
}
function emailLead(stage){
  if(!OWNER_EMAIL || OWNER_EMAIL.indexOf('REPLACE')===0) return; /* not configured yet */
  const L=S.lead; if(!L) return;
  const {t,c}=selTotal();
  fetch('https://formsubmit.co/ajax/'+OWNER_EMAIL,{
    method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({
      _subject:'🏥 Planner Lead: '+L.name+' — '+projectLabel(),
      Stage:stage, Name:L.name, Qualification:L.degree, Location:L.city,
      Email:L.email, Mobile:L.phone, PINCode:L.pin||'—', Consent:'Yes @ '+L.ts, Project:projectLabel(),
      Budget:fmtBig(t)+' ('+c+' items)',
      Services: SERVICES.filter(s=>S.services&&S.services[s.id]).map(s=>s.tl).join(', ')||'None selected',
      Time:L.ts
    })
  }).catch(()=>{});
}

/* ================= OUTPUT ================= */
function buildListText(){
  const {t} = selTotal();
  const L = S.lead||{};
  let items=[];
  function pushDept(store, deptOn){
    DEPTS.forEach(d=>{
      if(!deptOn(d)) return;
      const sel = HITEMS.filter(it=>it.dp===d.id && store[it.id] && store[it.id].on);
      if(sel.length){ items.push(`\n*${d.nm}:*`); sel.forEach(it=>items.push(`• ${it.nm} × ${store[it.id].q}`)); }
    });
  }
  if(S.mode==='clinic'){
    activeClinicItems().forEach(it=>{const s=S.items[it.id]; if(s&&s.on) items.push(`• ${it.nm} × ${s.q}`);});
  }else if(S.mode==='hosp'){
    pushDept(S.hitems, d=>S.depts&&S.depts[d.id]);
  }else{
    items.push('\n*— TEACHING HOSPITAL —*');
    pushDept(S.chitems, d=>true);
    items.push('\n*— COLLEGE BLOCK —*');
    CDEPTS.forEach(d=>{
      if(!S.cdepts||!S.cdepts[d.id]) return;
      const sel = CITEMS.filter(it=>it.dp===d.id && S.citems[it.id] && S.citems[it.id].on);
      if(sel.length){ items.push(`\n*${d.nm}:*`); sel.forEach(it=>items.push(`• ${it.nm} × ${S.citems[it.id].q}`)); }
    });
  }
  const svc = SERVICES.filter(s=>S.services&&S.services[s.id]).map(s=>'• '+s.tl+' — '+s.pf(t));
  return [`*QUOTE REQUEST — ${projectLabel()}*`,
   `Name: ${L.name||'—'} (${L.degree||'—'})`,`Location: ${L.city||'—'}`,
   `Email: ${L.email||'—'}`,`Mobile: ${L.phone||'—'}`,``,
   `*Items required:*`,...items,
   ...(myCustom().length?[``,`*Custom items (user-specified):*`,...myCustom().map(c=>`• ${c.nm}${c.spec?' — '+c.spec:''} × ${c.q}${c.pr?' @ '+fmt(c.pr):' (price on request)'}`)]:[]),``,
   `Approx budget: ${fmtBig(t)} (${fmt(t)})`,
   ...(svc.length?[``,`*Services interested in:*`,...svc]:[]),``,
   `Note: Budget figures are indicative estimates only — not an offer. Final quotation from Medsor Impex will apply.`,``,
   `Please share Medsor Impex best quote with GST & delivery.`].join('\n');
}
function shareApp(){
  const txt='🏥 Free Clinic / Hospital / Medical College Setup Planner by Medsor Impex — equipment lists, budgets & licence checklists for India. Try it: '+location.href;
  window.open('https://wa.me/?text='+encodeURIComponent(txt),'_blank');
}
let pendingAction = null;
function buildCompactText(){
  /* For very large projects: department subtotals instead of every line item, so the WhatsApp URL never truncates */
  const {t,c} = selTotal();
  const L = S.lead||{};
  let rows=[];
  function deptRows(store, deptOn){
    DEPTS.forEach(d=>{
      if(!deptOn(d)) return;
      let dt=0,n=0;
      HITEMS.filter(it=>it.dp===d.id).forEach(it=>{const x=store[it.id]; if(x&&x.on){dt+=hPrice(it)*x.q; n++;}});
      if(n) rows.push(`• ${d.nm}: ${n} items — ~${fmtBig(dt)}`);
    });
  }
  if(S.mode==='hosp') deptRows(S.hitems, d=>S.depts&&S.depts[d.id]);
  else if(S.mode==='college'){
    deptRows(S.chitems, d=>true);
    CDEPTS.forEach(d=>{
      if(!S.cdepts||!S.cdepts[d.id]) return;
      let dt=0,n=0;
      CITEMS.filter(it=>it.dp===d.id).forEach(it=>{const x=S.citems[it.id]; if(x&&x.on){dt+=it.pr*x.q; n++;}});
      if(n) rows.push(`• ${d.nm}: ${n} items — ~${fmtBig(dt)}`);
    });
  }
  (S.custom||[]).filter(x=>x.md===S.mode).forEach(x=>rows.push(`• [Custom] ${x.nm}${x.spec?' — '+x.spec:''} × ${x.q}`));
  const svc = SERVICES.filter(x=>S.services&&S.services[x.id]).map(x=>'• '+x.tl);
  return [`*QUOTE REQUEST — ${projectLabel()}*`,
   `Name: ${L.name||'—'} (${L.degree||'—'})`,`Location: ${L.city||'—'}${L.pin?' · PIN '+L.pin:''}`,
   `Email: ${L.email||'—'}`,`Mobile: ${L.phone||'—'}`,``,
   `*Department-wise summary (${c} line items):*`,...rows,``,
   `Approx budget: ${fmtBig(t)} — indicative estimate only`,
   ...(svc.length?[``,`*Services interested in:*`,...svc]:[]),``,
   `Full item-wise list available — please contact me for the detailed list and official quotation.`].join('\n');
}
function sendWhatsApp(){
  if(!(S.lead && S.lead.verified)){ pendingAction='wa'; openGate(); return; }
  let msg = buildListText();
  if(encodeURIComponent(msg).length > 5500) msg = buildCompactText();
  window.open('https://wa.me/'+OWNER_WHATSAPP+'?text='+encodeURIComponent(msg),'_blank');
}
function copyList(){
  if(!(S.lead && S.lead.verified)){ pendingAction='copy'; openGate(); return; }
  navigator.clipboard.writeText(buildListText()).then(()=>alert('Full list copied! Paste it anywhere — WhatsApp, email, notes.'));
}
function resetAll(){
  if(confirm('Clear all selections and start fresh? (Your registration stays)')){
    const lead = S.lead;
    localStorage.removeItem('csk3');
    S={mode:S.mode, spec:'gp', addons:{}, items:{}, beds:100, depts:null, hitems:{}, seats:100, cdepts:null, chitems:{}, citems:{}, services:{}, custom:[], lic:{}, lead:lead};
    defaultsClinic(); defaultsHosp(true); defaultsCollege(true);
    saveState(); renderAll(); goTab('setup');
  }
}
function saveState(){ try{ S.v=APP_VER; localStorage.setItem('csk3', JSON.stringify(S)); }catch(e){} }
const APP_VER = 5;
function loadState(){
  try{const d=localStorage.getItem('csk3'); if(d){const p=JSON.parse(d);
    if(p.v && p.v!==APP_VER){ localStorage.removeItem('csk3'); } else { S=p; }
    /* re-hydrate: functions aren't stored, only plain state, which is fine */
  }}catch(e){}
  defaultsClinic(); defaultsHosp(!S.depts); defaultsCollege(!S.cdepts);
  if(S.lead){
    document.getElementById('g_name').value=S.lead.name||'';
    document.getElementById('g_degree').value=S.lead.degree||'';
    document.getElementById('g_city').value=S.lead.city||'';
    document.getElementById('g_email').value=S.lead.email||'';
    document.getElementById('g_phone').value=S.lead.phone||'';
  }
}
loadState(); renderAll();
/* If embedded in an iframe (e.g. Shopify page), offer full-screen mode — storage & WhatsApp work best full-screen */
try{
  if(window.self !== window.top){
    const b=document.createElement('div');
    b.style.cssText='position:fixed;top:0;left:0;right:0;z-index:200;background:#15241F;color:#fff;font-size:.72rem;font-weight:600;text-align:center;padding:7px 10px';
    b.innerHTML='For the best experience → <a href="'+location.href+'" target="_top" style="color:#FFD9A0;font-weight:800">Open full app ↗</a>';
    document.body.appendChild(b);
  }
}catch(e){}